import { render, staticRenderFns } from "./Condominiums.vue?vue&type=template&id=d2645e66&scoped=true&"
import script from "./Condominiums.vue?vue&type=script&lang=js&"
export * from "./Condominiums.vue?vue&type=script&lang=js&"
import style0 from "./Condominiums.vue?vue&type=style&index=0&id=d2645e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2645e66",
  null
  
)

export default component.exports